import { render, staticRenderFns } from "./CompleteRuleModal.vue?vue&type=template&id=520caf58"
import script from "./CompleteRuleModal.vue?vue&type=script&lang=js"
export * from "./CompleteRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports